export default __webpack_public_path__ + "static/media/typescript-logo.29073194.png";